$(document).ready(function ($) {
  "use strict";

  $('.qa-column .question').on('click', function () {
    var $wrap = $(this).closest('.qa-column');
    if ($wrap.hasClass('active')) {
      $('.qa-column .answer').slideUp();
      $('.qa-column.active').removeClass('active');
    } else {
      $('.qa-column .answer').slideUp();
      $('.qa-column.active').removeClass('active');
      $wrap.find('.answer').slideDown();
      $wrap.addClass('active');
    }
  });
});